import { User } from '../../../types/shared';
import { MenuHeader } from '../../menu/menu-mobile/menu-header/menu-header';
import { StyledMenuMobile } from '../../menu/menu-mobile/menu-mobile.styles';
import { createSignal, Match, Show, Switch, useContext } from 'solid-js';
import { StyledVerticalSpace } from '../../../ui-components/utility-style-components/spacing';
import { Button } from '../../../ui-components/button/button';
import { AppContext } from '../../../app-context-provider/app-context-provider';
import { UserOrderHistory } from '../../order-history/user-order-history';
import { TabHandler } from '../../menu/menu-desktop/tab-handling';
import { StyledLoginMenuSignedInAsBoldMobile, StyledLoginMenuSignedInAsContentMobile, StyledLoginMenuSignedInAsMobile, StyledMenuHeaderLink, StyledMenuHeaderLinks } from './user-profile-menu-mobile.styles';
import { AccountEducationContent } from '../../account-education-content/account-education-content';
import { MyContent } from '../../my-content/my-content';

type UserProfileMenuMobileProps = {
    user: User | null;
    handleCloseMenuClick: () => void;
    handleSignOutClick: () => void;
};

export const UserProfileMenuMobile = (props: UserProfileMenuMobileProps) => {
    const { localize, siteInfo } = useContext(AppContext);

    const [ activeView, setActiveView ] = createSignal(siteInfo.siteType === 'atos-care' ? 'orders' : 'my-content');

    // Accessibility/keyboard-controls related
    const [ firstTabbableElement, setFirstTabbableElement ] = createSignal<HTMLElement | undefined>();
    const [ lastTabbableElement, setLastTabbableElement ] = createSignal<HTMLElement | undefined>();

    const Navigation = () => (
        <StyledMenuHeaderLinks>
            <Show when={siteInfo.siteType !== 'atos-care'}>
                <StyledMenuHeaderLink
                    onClick={() => setActiveView('my-content')}
                    active={activeView() === 'my-content'}
                >
                    <span>{localize('my-content', 'My content')}</span>
                </StyledMenuHeaderLink>
                <StyledMenuHeaderLink
                    onClick={() => setActiveView('learning')}
                    active={activeView() === 'learning'}
                >
                    <span>{localize('e-learning', 'E-learning')}</span>
                </StyledMenuHeaderLink>
            </Show>

            <Show when={siteInfo.siteType === 'atos-care'}>
                <StyledMenuHeaderLink
                    onClick={() => setActiveView('orders')}
                    active={activeView() === 'orders'}
                >
                    <span>{localize('orders', 'Orders')}</span>
                </StyledMenuHeaderLink>
            </Show>
        </StyledMenuHeaderLinks>
    );


    return (
        <TabHandler
            refs={{
                firstTabbableElement,
                lastTabbableElement,
            }}
        >
            <StyledMenuMobile>

                <MenuHeader
                    handleCloseMenuClick={props.handleCloseMenuClick}
                    firstElement={(el: HTMLElement) => {
                        setFirstTabbableElement(el);
                    }}
                />

                <StyledLoginMenuSignedInAsContentMobile>
                    <StyledLoginMenuSignedInAsMobile>
                        <StyledLoginMenuSignedInAsBoldMobile>
                            {localize('signed-in-as', 'Signed in as')}
                        </StyledLoginMenuSignedInAsBoldMobile>
                        <div>{props.user?.firstName || props.user?.email || ''}</div>
                    </StyledLoginMenuSignedInAsMobile>
                    <StyledVerticalSpace size={1} />
                    <Button
                        label={localize('sign-out', 'Sign out')}
                        onClick={() => props.handleSignOutClick()}
                        small
                    />
                </StyledLoginMenuSignedInAsContentMobile>

                <Navigation />

                <Switch>
                    <Match when={activeView() === 'my-content'}>
                        <MyContent lastElement={(el: HTMLElement) => setLastTabbableElement(el)} />
                    </Match>
                    <Match when={activeView() === 'learning'}>
                        <AccountEducationContent lastElement={(el: HTMLElement) => setLastTabbableElement(el)} />
                    </Match>
                    <Match when={activeView() === 'orders'}>
                        <UserOrderHistory lastElement={(el: HTMLElement) => setLastTabbableElement(el)} />
                    </Match>
                </Switch>
            </StyledMenuMobile>
        </TabHandler>
    );
};
